export type CategoriaUnidad = 'SERVICIOS' | 'TIME' | 'WEIGHT' | 'VOLUME' | 'LENGTH' | 'AREA' | 'ENERGY' | 'QUANTITY' | 'PACKAGING' | 'OTHER';

export interface Unidad {
  id: string;
  codigo: string;
  nombre: string;
  simbolo: string;
  descripcion: string;
  categoria: CategoriaUnidad;
  unidadBase?: string;
  factorConversion?: number;
  lugaresDecimales: number;
  estaActivo: boolean;
  esSistema?: boolean;
  esFavorito?: boolean;
  esVisible?: boolean;
  ordenVisualizacion?: number;
  contadorUso?: number;
  creadoEn: Date;
  actualizadoEn: Date;
}

export interface SolicitudCrearUnidad {
  codigo: string;
  nombre: string;
  simbolo: string;
  descripcion: string;
  categoria: CategoriaUnidad;
  unidadBase?: string;
  factorConversion?: number;
  lugaresDecimales: number;
}

export interface SolicitudActualizarUnidad extends Partial<SolicitudCrearUnidad> {
  id: string;
}

export interface ResumenUnidad {
  id: string;
  codigo: string;
  nombre: string;
  simbolo: string;
  categoria: CategoriaUnidad;
  estaActivo: boolean;
}

export const CATEGORIAS_UNIDAD = [
  { valor: 'SERVICIOS', etiqueta: 'Servicios', icono: 'Layers' },
  { valor: 'TIME', etiqueta: 'Tiempo', icono: 'Clock' },
  { valor: 'WEIGHT', etiqueta: 'Peso', icono: 'Scale' },
  { valor: 'VOLUME', etiqueta: 'Volumen', icono: 'Box' },
  { valor: 'LENGTH', etiqueta: 'Longitud', icono: 'Ruler' },
  { valor: 'AREA', etiqueta: 'Área', icono: 'Square' },
  { valor: 'ENERGY', etiqueta: 'Energía', icono: 'Zap' },
  { valor: 'QUANTITY', etiqueta: 'Cantidad', icono: 'Hash' },
  { valor: 'PACKAGING', etiqueta: 'Empaque', icono: 'Package' },
  { valor: 'OTHER', etiqueta: 'Otros', icono: 'MoreHorizontal' },
] as const;

export function mapearCategoriaDesdeBackend(categoriaCodigo?: string): CategoriaUnidad {
  if (!categoriaCodigo) return 'OTHER';
  const categoriaUpper = categoriaCodigo.toUpperCase();
  const mapa: Record<string, CategoriaUnidad> = {
    'SERVICIO': 'SERVICIOS',
    'SERVICIOS': 'SERVICIOS',
    'TIEMPO': 'TIME',
    'TIME': 'TIME',
    'CANTIDAD': 'QUANTITY',
    'QUANTITY': 'QUANTITY',
    'PESO': 'WEIGHT',
    'WEIGHT': 'WEIGHT',
    'LONGITUD': 'LENGTH',
    'LENGTH': 'LENGTH',
    'AREA': 'AREA',
    'VOLUMEN': 'VOLUME',
    'VOLUME': 'VOLUME',
    'ENERGIA': 'ENERGY',
    'ENERGÍA': 'ENERGY',
    'ENERGY': 'ENERGY',
    'EMPAQUE': 'PACKAGING',
    'PACKAGING': 'PACKAGING',
    'OTRO': 'OTHER',
    'OTHER': 'OTHER',
  };
  return mapa[categoriaUpper] || 'OTHER';
}

export function mapearCategoriaHaciaBackend(categoria: CategoriaUnidad): string {
  const mapaEspanol: Record<CategoriaUnidad, string> = {
    'SERVICIOS': 'SERVICIOS',
    'TIME': 'TIEMPO',
    'QUANTITY': 'CANTIDAD',
    'WEIGHT': 'PESO',
    'LENGTH': 'LONGITUD',
    'AREA': 'AREA',
    'VOLUME': 'VOLUMEN',
    'ENERGY': 'ENERGIA',
    'PACKAGING': 'EMPAQUE',
    'OTHER': 'OTRO',
  };
  return mapaEspanol[categoria];
}

export type Unit = {
  id: string;
  code: string;
  name: string;
  symbol: string;
  description: string;
  category: CategoriaUnidad;
  baseUnit?: string;
  conversionFactor?: number;
  decimalPlaces: number;
  isActive: boolean;
  isSystem?: boolean;
  isFavorite?: boolean;
  isVisible?: boolean;
  isDefault?: boolean;
  displayOrder?: number;
  usageCount?: number;
  createdAt: Date;
  updatedAt: Date;
};

export const UNIT_CATEGORIES = CATEGORIAS_UNIDAD.map(c => ({
  value: c.valor,
  label: c.etiqueta,
  icon: c.icono,
}));
